import React, { useContext } from 'react'
import { FormContext } from './FormContext'

export type InputProps = React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> & {
  label: string
}

const Input: React.FC<InputProps> = ({ label, ...props }) => {
  const { scope } = useContext(FormContext)
  const name = scope && props.name ? `${scope}[${props.name}]` : props.name

  return (
    <div className={['form-input-input', props.className].filter((x) => !!x).join(' ')}>
      <input
        {...props}
        type={props.type ?? 'text'}
        name={name}
        placeholder={label ?? props.placeholder}
        className="form__input"
      />
    </div>
  )
}

export default Input
